<script>
import Loader from '@/components/widgets/loader';
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    valueTitle: {
      type: [String, Number],
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    component: {
      type: Object,
      default: undefined
    }
  }
};
</script>

<template>
  <Loader :loading="loading">
    <component v-if="component" :is="component" v-bind="$attrs" :value="value" :title="title"/>
    <div class="card mini-stats-wid border-0" v-else>
      <div class="card-body">
        <div class="media">
          <div class="media-body">
            <p class="stat-title">{{title}}</p>
            <h4 class="mb-0" :title="valueTitle">{{value}}</h4>
          </div>

          <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary" v-if="icon && !loading">
          <span class="avatar-title">
            <i :class="`${icon} font-size-24`"></i>
          </span>
          </div>

        </div>
      </div>
      <!-- end card-body -->
    </div>
    <!-- end card -->
  </Loader>
</template>


<style lang="scss" scoped>
::v-deep {
.preloader-component {
  right: 20px !important;
  background-color: rgba(255,255,255,0.5);
}
.status {
  left: 90%;
  right: 10%;
.spinner-chase {
  width: 24px;
  height: 24px;
  margin: 8px;
}
}
}
 .stat-title {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0 !important;
 }
</style>